export const GET_ADMIN_WITHDRAWALS = "GET_ADMIN_WITHDRAWALS";
export const GET_ADMIN_WITHDRAWALS_SUCCESS = "GET_ADMIN_WITHDRAWALS_SUCCESS";
export const GET_ADMIN_WITHDRAWALS_FAILURE = "GET_ADMIN_WITHDRAWALS_FAILURE";

export const APPROVE_WITHDRAWAL = "APPROVE_WITHDRAWAL";
export const APPROVE_WITHDRAWAL_SUCCESS = "APPROVE_WITHDRAWAL_SUCCESS";
export const APPROVE_WITHDRAWAL_FAILURE = "APPROVE_WITHDRAWAL_FAILURE";

export const REJECT_WITHDRAWAL = "REJECT_WITHDRAWAL";
export const REJECT_WITHDRAWAL_SUCCESS = "REJECT_WITHDRAWAL_SUCCESS";
export const REJECT_WITHDRAWAL_FAILURE = "REJECT_WITHDRAWAL_FAILURE";
